// skipcq: JS-W1028
import DashboardIcon from '@mui/icons-material/Dashboard';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ReviewsIcon from '@mui/icons-material/Reviews';
import SettingsIcon from '@mui/icons-material/Settings';

/** @typedef {'brewhouse' | 'pint-portfolio' | 'review-details' | 'settings' | 'claim' | 'claim-status'} BrewhouseNavAnalyticsItem */

/**
 * @typedef {object} BrewhousePortalNavItem
 * @property {string} text
 * @property {string} path
 * @property {BrewhouseNavAnalyticsItem} analyticsItem
 * @property {import('react').ReactNode} icon
 * @property {boolean} [requiresBreweryAdmin]
 */

/** @type {BrewhousePortalNavItem[]} */
export const brewhousePortalNavItems = [
  {
    text: 'Brewhouse',
    path: '/brewery-portal/dashboard',
    analyticsItem: 'brewhouse',
    icon: <DashboardIcon />,
    requiresBreweryAdmin: true,
  },
  {
    text: 'Review Details',
    path: '/brewery-portal/review-details',
    analyticsItem: 'review-details',
    icon: <ReviewsIcon />,
    requiresBreweryAdmin: true,
  },
  {
    text: 'Pint Portfolio',
    path: '/brewery-portal/pint-portfolio',
    analyticsItem: 'pint-portfolio',
    icon: <SportsBarIcon />,
    requiresBreweryAdmin: true,
  },
  {
    text: 'Settings',
    path: '/brewery-portal/email-preferences',
    analyticsItem: 'settings',
    icon: <SettingsIcon />,
    requiresBreweryAdmin: true,
  },
  {
    text: 'Claim',
    path: '/brewery-portal/claim',
    analyticsItem: 'claim',
    icon: <AssignmentIndIcon />,
  },
  {
    text: 'Claim Status',
    path: '/brewery-portal/status',
    analyticsItem: 'claim-status',
    icon: <RateReviewIcon />,
  },
];

/**
 * @param {boolean} isBreweryAdmin
 * @returns {BrewhousePortalNavItem[]}
 */
export function getVisibleBrewhousePortalNavItems(isBreweryAdmin) {
  return brewhousePortalNavItems.filter(
    (navItem) => isBreweryAdmin === true || navItem.requiresBreweryAdmin !== true,
  );
}
